import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Grid,
  IconButton,
  InputBase,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  tableCellClasses,
} from "@mui/material";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import Fuse from "fuse.js";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { v4 as uuid } from "uuid";
import { GetEnumsResponse } from "../../models/enum.model";
import {
  GetPermissionGroupsResponse,
  GetPermissionGroupsWithSubPermissionsResponse,
  GetPermissionSubGroupsResponse,
  GetPermissionsSearchResponse,
} from "../../models/permission.model";
import { GetEnums } from "../../services/enum.services";
import {
  DeletePermissionGroup,
  GetPermissionGroups,
  GetPermissionGroupsWithSubPermissions,
} from "../../services/permission.service";
import AccordionSkeleton from "./components/AccordionSkeleton";
import AddEditPermissionModal from "./components/AddEditPermissionModal";
import AddEditSubPermissionModal from "./components/AddEditSubPermissionModal";
import PermissionAccardionTableRows from "./components/PermissionAccardionTableRows";
import TabsEmptyStyle from "./components/TabsEmptyStyle";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={
      <ArrowDropDownIcon sx={{ fontSize: "2rem", color: "#1D4A87" }} />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#DAE0E4",
    color: "#1D4A87",
    fontSize: "14px",
    marginBottom: "50px",
  },
}));
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const columns = [
  {
    id: 1,
    title: "عنوان دسترسی",
  },
  {
    id: 2,
    title: "نوع دسترسی",
  },
  {
    id: 3,
    title: "گروه دسترسی",
  },
  {
    id: 4,
    title: "سامانه",
  },

  {
    id: 5,
    title: "تاریخ و زمان ایجاد دسترسی",
  },
  {
    id: 6,
    title: "ایجاد کننده دسترسی",
  },
];

const DefinePermission = () => {
  const [expanded, setExpanded] = useState<string | false>("panel1");
  const [permissionList, setPermissionList] = useState<
    GetPermissionGroupsWithSubPermissionsResponse[]
  >([]);
  const [updateReports, setUpdateReports] = useState("");
  const [openAddPermissionModal, setOpenAddPermissionModal] = useState(false);
  const [openAddSubPermissonModal, setOpenAddSubPermissonModal] = useState(
    false
  );
  const [addOrEdit, setAddOrEdit] = useState<"Add" | "Edit">();
  const [choosedPermission, setChoosedPermission] = useState<
    GetPermissionGroupsWithSubPermissionsResponse
  >();
  const [searchTerm, setSearchTerm] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [permissionTypesOptions, setPermissionTypesOptions] = useState<
    GetEnumsResponse[]
  >();
  const [permissionGroupsOptions, setPermissionGroupsOptions] = useState<
    GetPermissionGroupsResponse[]
  >();
  const [reportAccessOptions, setReportAccessOptions] = useState<
    GetPermissionsSearchResponse[]
  >();
  const [subPermission, setSubPermission] = useState<
    GetPermissionSubGroupsResponse
  >();

  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value.trim().toLocaleLowerCase());
  };

  const handleChange = (panel: string) => (
    event: React.SyntheticEvent,
    newExpanded: boolean
  ) => {
    setExpanded(newExpanded ? panel : false);
  };

  const {
    mutate: GetPermissionGroupsWithSubPermissionsMutate,
    isLoading,
  } = useMutation(GetPermissionGroupsWithSubPermissions, {
    onSuccess: (data: GetPermissionGroupsWithSubPermissionsResponse[]) => {
      if (data) {
        setPermissionList(data);
      }
    },
    onError: () => {},
  });

  const { mutate: DeletePermissionGroupMutate } = useMutation(
    DeletePermissionGroup,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          setUpdateReports(uuid());
          setOpenDeleteModal(false);
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetEnumsMutate } = useMutation(GetEnums, {
    onSuccess: (data: GetEnumsResponse[]) => {
      if (data) {
        setPermissionTypesOptions(data);
      }
    },
    onError: () => {},
  });

  const { mutate: GetPermissionGroupsMutate } = useMutation(
    GetPermissionGroups,
    {
      onSuccess: (data: GetPermissionGroupsResponse[]) => {
        if (data) {
          setPermissionGroupsOptions(data);
        }
      },
      onError: () => {},
    }
  );

  useEffect(() => {
    GetEnumsMutate({
      enumNames: ["PermissionType"],
    });
  }, []);

  useEffect(() => {
    GetPermissionGroupsWithSubPermissionsMutate({});
    GetPermissionGroupsMutate({});
  }, [updateReports]);

  const fuse = new Fuse(permissionList, {
    keys: ["title", "name", "subPermissions.title", "subPermissions.name"],
    includeScore: true,
    threshold: 0.1,
    ignoreLocation: true,
    useExtendedSearch: true,
  });
  const results = fuse.search(searchTerm);
  const titleResults = searchTerm
    ? results.map((title) => title.item)
    : permissionList;

  return (
    <>
      <Box
        width={"100%"}
        height={{
          xs: "fit-content",
          sm: "fit-content",
          md: "95vh",
          lg: "85vh",
        }}
        border={"2px solid #DAE0E4"}
        borderRadius={"5px"}
        padding={"2rem"}
        position={"relative"}
      >
        <Typography
          style={{
            color: "#1D4A87",
            fontSize: "18px",
            width: "fit-content",
            marginTop: "-40px",
            marginRight: "23px",
            background: "#fff",
            marginBottom: "15px",
          }}
          sx={{ paddingX: "5px" }}
        >
          گروه دسترسی
        </Typography>
        <Grid container gap={"20px"}>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography
                color={"#28A745"}
                fontWeight={"bold"}
                padding={"0.5rem"}
                borderRadius={"5px"}
                sx={{
                  cursor: "pointer",
                  width: "fit-content",
                  "&: hover": { color: "#fff", background: "#28A745" },
                }}
                onClick={() => {
                  setOpenAddPermissionModal(true);
                  setAddOrEdit("Add");
                }}
              >
                <AddCircleOutlineIcon sx={{ marginLeft: "7px" }} />
                افزودن گروه دسترسی
              </Typography>
              <span
                style={{
                  marginLeft: "2vh",
                  marginRight: "2vh",
                  background: "#CFD8DC",
                  height: "3vh",
                  width: "2px",
                }}
              ></span>
              <Paper
                elevation={0}
                style={{
                  border: "1px solid #DAE0E4",
                  display: "flex",
                  borderRadius: "5px",
                  height: "35px",
                  width: "20vw",
                }}
                square={true}
              >
                <InputBase
                  sx={{
                    ml: 1,
                    flex: 1,
                    paddingX: "16px",
                    height: "30px !important",
                  }}
                  placeholder="جستجو"
                  onChange={handleSearchInput}
                />

                <IconButton
                  type="button"
                  sx={{ color: "#9AAFC4" }}
                  aria-label="search"
                >
                  <SearchIcon />
                </IconButton>
              </Paper>
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ height: "73vh", overflowY: "auto" }}>
            {!isLoading ? (
              titleResults.length > 0 ? (
                titleResults?.map((permission, index) => (
                  <Accordion
                    // expanded={expanded === `panel${index + 1}`}
                    // onChange={handleChange(`panel${index + 1}`)}
                    defaultExpanded={index === 0}
                  >
                    <AccordionSummary
                      aria-controls={`panel${index + 1}d-content`}
                      id={`panel${index + 1}d-header`}
                      sx={{
                        background: index % 2 === 0 ? "#fff" : "",
                        width: "100%",
                      }}
                    >
                      <Grid
                        container
                        sx={{ justifyContent: "space-between !important" }}
                      >
                        <Grid item>
                          <Typography
                            sx={{
                              marginRight: "1.5rem",
                              fontWeight: "bold",
                              color: "#1D4A87",
                            }}
                          >
                            {permission.title} ({permission.total} مورد)
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Grid container gap={"7px"}>
                            <Grid
                              item
                              onClick={(e) => {
                                e.stopPropagation();
                                setOpenAddSubPermissonModal(true);
                                setAddOrEdit("Add");
                                setChoosedPermission(permission);
                              }}
                            >
                              <AddCircleOutlineIcon
                                sx={{
                                  color: "#9AAFC4",
                                  "&: hover": { color: "#1D4A87" },
                                }}
                              />
                            </Grid>
                            <Grid
                              item
                              onClick={(e) => {
                                e.stopPropagation();
                                setAddOrEdit("Edit");
                                setOpenAddPermissionModal(true);
                                setChoosedPermission(permission);
                              }}
                            >
                              <ModeEditOutlinedIcon
                                sx={{
                                  color: "#9AAFC4",
                                  "&: hover": { color: "#1D4A87" },
                                }}
                              />
                            </Grid>
                            <Grid
                              item
                              onClick={(e) => {
                                if (permission.subPermissions.length === 0) {
                                  e.stopPropagation();
                                  setChoosedPermission(permission);
                                  setOpenDeleteModal(true);
                                }
                              }}
                            >
                              <DeleteOutlineOutlinedIcon
                                sx={
                                  permission.subPermissions.length === 0
                                    ? {
                                        color: "#9AAFC4",
                                        "&: hover": { color: "#1D4A87" },
                                      }
                                    : {
                                        color: "#9AAFC4",
                                        "&: hover": { cursor: "not-allowed" },
                                      }
                                }
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    {permission.subPermissions.length > 0 && (
                      <AccordionDetails>
                        <Typography className="userReport-list">
                          <TableContainer
                            component={Paper}
                            sx={{ maxHeight: 440 }}
                          >
                            <Table
                              stickyHeader
                              sx={{
                                minWidth: { xs: 0, sm: 0, md: 700, lg: 900 },
                              }}
                              aria-label="customized table"
                            >
                              <TableHead>
                                <TableRow>
                                  {columns.length > 0 &&
                                    columns.map((column) => (
                                      <StyledTableCell align="center">
                                        {column.title}
                                      </StyledTableCell>
                                    ))}
                                  <StyledTableCell align="center">
                                    <MoreHorizIcon />
                                  </StyledTableCell>
                                </TableRow>
                              </TableHead>

                              <TableBody
                                sx={{
                                  outline: "1px solid #DAE0E4",
                                }}
                              >
                                {permission.subPermissions.map(
                                  (item: GetPermissionSubGroupsResponse) => (
                                    <PermissionAccardionTableRows
                                      permissions={item}
                                      key={item.id}
                                      setUpdateReports={setUpdateReports}
                                      setSubPermission={setSubPermission}
                                      setAddOrEdit={setAddOrEdit}
                                      setOpenAddSubPermissionModal={
                                        setOpenAddSubPermissonModal
                                      }
                                    />
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Typography>
                      </AccordionDetails>
                    )}
                  </Accordion>
                ))
              ) : (
                <TabsEmptyStyle height="73vh" text="گروه دسترسی" />
              )
            ) : (
              <AccordionSkeleton />
            )}
          </Grid>
        </Grid>
        <div>
          <AddEditPermissionModal
            openAddPermissionModal={openAddPermissionModal}
            setOpenAddPermissionModal={setOpenAddPermissionModal}
            setUpdateReports={setUpdateReports}
            addOrEdit={addOrEdit!}
            choosedPermission={choosedPermission!}
          />
          <AddEditSubPermissionModal
            setOpenAddSubReportModal={setOpenAddSubPermissonModal}
            openAddSubReportModal={openAddSubPermissonModal}
            addOrEdit={addOrEdit!}
            setUpdateReports={setUpdateReports}
            permissionTypesOptions={permissionTypesOptions!}
            permissionGroupsOptions={permissionGroupsOptions!}
            subPermission={subPermission!}
          />
        </div>
        <div>
          <Modal
            open={openDeleteModal}
            onClose={() => setOpenDeleteModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={deactiveUserStyle}>
              <Typography
                component={"p"}
                display={"block"}
                textAlign={"center"}
                fontWeight={"bold"}
                marginY={"3rem"}
                fontSize={"14px"}
              >
                آیا از حذف کردن{" "}
                <span style={{ color: "#E6123D" }}>
                  "{choosedPermission?.title}"
                </span>{" "}
                اطمینان دارید؟
              </Typography>
              <Grid container justifyContent={"center"} gap={"1rem"}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  sx={{
                    backgroundColor: "#E6123D",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  padding={"0.5rem"}
                  maxWidth={"150px !important"}
                >
                  <Typography
                    textAlign={"center"}
                    color={"#FFF"}
                    fontWeight={"bold"}
                    onClick={() => {
                      DeletePermissionGroupMutate({
                        permissionGroupId: choosedPermission?.id!,
                      });
                    }}
                  >
                    بله
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  sx={{
                    backgroundColor: "#607D8B",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                  padding={"0.5rem"}
                  maxWidth={"150px !important"}
                >
                  <Typography
                    textAlign={"center"}
                    color={"#FFF"}
                    fontWeight={"bold"}
                    onClick={() => setOpenDeleteModal(false)}
                  >
                    خیر
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Modal>
        </div>
      </Box>
    </>
  );
};

export default DefinePermission;
